<ng-container *ngIf="hasItemsButNoProperty !== null">
  <div class="text-container">
    <ng-container
      [ngTemplateOutlet]="emptyState"
      [ngTemplateOutletContext]="{ type: hasItemsButNoProperty ? 'property' : 'item' }"
    ></ng-container>
  </div>
  <div class="sm-flex sm-flex-row sm-justify-center sm-gap-x-2">
    <button
      type="button"
      class="button-regular button-green"
      (click)="addAction()"
      [attr.data-action-button]="hasItemsButNoProperty ? 'addListProperty' : 'addListItem'"
    >
      <span class="sm-pointer-events-none"> Add {{ hasItemsButNoProperty ? 'property' : 'item' }} </span>
    </button>
    <a [href]="helpLink" class="button-regular learn-more" target="_blank">
      <i class="cc-icon cc-icon-question"></i>
      <span> Learn more </span>
    </a>
  </div>
  <button type="button" class="csv-import" (click)="importAction()">or upload list items</button>

  <ng-template #emptyState let-type="type">
    <img
      class="empty-{{ pluralisedEntity }}"
      [src]="imageURL"
      alt="Populate some list {{ pluralisedEntity }}"
    />
    <h1>Populate some list {{ pluralisedEntity }}</h1>
    <span>{{ helpText }}</span>
  </ng-template>
</ng-container>
